export const CLASS_NAME_MAP = {
    icons: 'icons',
    level: 'level',
    bookTitle: 'book-title',
    complexityLevel: 'complexity-level',
    performance: 'performance',
    accuracy: 'accuracy',
    fluency: 'fluency',
    comprehension: 'comprehension',
};

export const TABLE_COLUMNS = [
    {
        dataKey: 'icons',
        label: '',
        width: 40,
        headerClassName: CLASS_NAME_MAP.icons,
    },
    {
        dataKey: 'level',
        label: 'Level',
        width: 50,
        headerClassName: CLASS_NAME_MAP.level,
    },
    {
        dataKey: 'bookTitle',
        label: 'Book Title',
        width: 250,
        headerClassName: CLASS_NAME_MAP.bookTitle,
    },
    {
        dataKey: 'complexityLevel ',
        label: 'Complexity Level',
        width: 140,
        headerClassName: CLASS_NAME_MAP.complexityLevel,
    },
    {
        dataKey: 'performance',
        label: 'Performance',
        width: 110,
        headerClassName: CLASS_NAME_MAP.performance,
    },
    {
        dataKey: 'accuracy',
        label: 'Accuracy',
        width: 80,
        headerClassName: CLASS_NAME_MAP.accuracy,
    },
    {
        dataKey: 'fluency',
        label: 'Fluency',
        width: 100,
        headerClassName: CLASS_NAME_MAP.fluency,
    },
    {
        dataKey: 'comprehension',
        label: 'Comprehension',
        width: 130,
        headerClassName: CLASS_NAME_MAP.comprehension,
    },
];
export const SUMMARY_MEASUREMENTS = {
    headerHeight: 30,
    rowHeight: 60,
};

export const SUMMARY_INVALID_MEASUREMENTS = {
    headerHeight: 0,
    rowHeight: 60,
};

export const NOT_DISPLAYING_FIELDS_FOR_SUMMARY = ['id', 'isValid', 'audioSrc'];
